var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMsgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0539 17.9572C19.3388 17.9572 15.5165 21.7795 15.5165 26.4946C15.5165 31.2096 19.3388 35.032 24.0539 35.032H35.0699V39.9891H24.0539C16.6011 39.9891 10.5593 33.9474 10.5593 26.4946C10.5593 19.0417 16.6011 13 24.0539 13H35.0699C36.4388 13 37.5485 14.1097 37.5485 15.4786C37.5485 16.8475 36.4388 17.9572 35.0699 17.9572H24.0539Z",
    fill: "url(#paint0_linear_8159_26788)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0539 17.9572C19.3388 17.9572 15.5165 21.7795 15.5165 26.4946C15.5165 31.2096 19.3388 35.032 24.0539 35.032H35.0699V39.9891H24.0539C16.6011 39.9891 10.5593 33.9474 10.5593 26.4946C10.5593 19.0417 16.6011 13 24.0539 13H35.0699C36.4388 13 37.5485 14.1097 37.5485 15.4786C37.5485 16.8475 36.4388 17.9572 35.0699 17.9572H24.0539Z",
    fill: "url(#paint1_linear_8159_26788)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0539 17.9572C19.3388 17.9572 15.5165 21.7795 15.5165 26.4946C15.5165 31.2096 19.3388 35.032 24.0539 35.032H35.0699V39.9891H24.0539C16.6011 39.9891 10.5593 33.9474 10.5593 26.4946C10.5593 19.0417 16.6011 13 24.0539 13H35.0699C36.4388 13 37.5485 14.1097 37.5485 15.4786C37.5485 16.8475 36.4388 17.9572 35.0699 17.9572H24.0539Z",
    fill: "url(#paint2_linear_8159_26788)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4661 15.4786C38.4661 16.8475 37.3564 17.9572 35.9875 17.9572H35.9874C34.6185 17.9572 33.5088 16.8475 33.5088 15.4786C33.5088 14.1097 34.6185 13 35.9874 13H35.9875C37.3564 13 38.4661 14.1097 38.4661 15.4786Z",
    fill: "#262AFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0699 24.9678C39.7849 24.9678 43.6073 28.7901 43.6073 33.5052C43.6073 38.2203 39.7849 42.0426 35.0699 42.0426H24.0539C22.685 42.0426 21.5753 43.1523 21.5753 44.5212C21.5753 45.8901 22.685 46.9998 24.0539 46.9998H35.0699C42.5227 46.9998 48.5645 40.958 48.5645 33.5052C48.5645 26.0523 42.5227 20.0106 35.0699 20.0106H24.0539V24.9678H35.0699Z",
    fill: "url(#paint3_linear_8159_26788)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0699 24.9678C39.7849 24.9678 43.6073 28.7901 43.6073 33.5052C43.6073 38.2203 39.7849 42.0426 35.0699 42.0426H24.0539C22.685 42.0426 21.5753 43.1523 21.5753 44.5212C21.5753 45.8901 22.685 46.9998 24.0539 46.9998H35.0699C42.5227 46.9998 48.5645 40.958 48.5645 33.5052C48.5645 26.0523 42.5227 20.0106 35.0699 20.0106H24.0539V24.9678H35.0699Z",
    fill: "url(#paint4_linear_8159_26788)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0699 24.9678C39.7849 24.9678 43.6073 28.7901 43.6073 33.5052C43.6073 38.2203 39.7849 42.0426 35.0699 42.0426H24.0539C22.685 42.0426 21.5753 43.1523 21.5753 44.5212C21.5753 45.8901 22.685 46.9998 24.0539 46.9998H35.0699C42.5227 46.9998 48.5645 40.958 48.5645 33.5052C48.5645 26.0523 42.5227 20.0106 35.0699 20.0106H24.0539V24.9678H35.0699Z",
    fill: "url(#paint5_linear_8159_26788)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5328 44.5214C26.5328 45.8903 25.4231 47 24.0542 47H24.0542C22.6853 47 21.5756 45.8903 21.5756 44.5214C21.5756 43.1525 22.6853 42.0428 24.0542 42.0428H24.0542C25.4231 42.0428 26.5328 43.1525 26.5328 44.5214Z",
    fill: "#262AFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5049 24.9678C23.7997 24.9678 23.2281 25.5395 23.2281 26.2447C23.2281 26.9498 23.7997 27.5215 24.5049 27.5215H34.4694V32.4787H24.5049C21.0619 32.4787 18.2709 29.6876 18.2709 26.2447C18.2709 22.8017 21.062 20.0106 24.5049 20.0106H34.4694V24.9678H24.5049Z",
    fill: "#262AFF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5686 32.4784C35.2738 32.4784 35.8454 33.05 35.8454 33.7552C35.8454 34.4604 35.2738 35.0321 34.5686 35.0321H24.6041V39.9893H34.5686C38.0115 39.9893 40.8026 37.1982 40.8026 33.7552C40.8026 30.3123 38.0115 27.5212 34.5686 27.5212H24.6041V32.4784H34.5686Z",
    fill: "#262AFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8159_26788",
    x1: 35.0698,
    y1: 18.066,
    x2: 14.8739,
    y2: 15.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FA3DE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FA3DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8159_26788",
    x1: 17.1689,
    y1: 19.443,
    x2: 19.0049,
    y2: 36.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#262AFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8159_26788",
    x1: 23.1359,
    y1: 13.935,
    x2: 11.6609,
    y2: 28.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#262AFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548077,
    stopColor: "#262AFF",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8159_26788",
    x1: 24.0539,
    y1: 45.1471,
    x2: 43.3319,
    y2: 36.8851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FA3DE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FA3DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8159_26788",
    x1: 36.9059,
    y1: 40.5571,
    x2: 44.2499,
    y2: 26.7871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#262AFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8159_26788",
    x1: 40.1189,
    y1: 22.6561,
    x2: 55.7249,
    y2: 35.0491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#262AFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262AFF",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsgLogo);
export default __webpack_public_path__ + "static/media/msg-logo.72e85591518e10dfdf50cd0e5b43ee54.svg";
export { ForwardRef as ReactComponent };